const ajaxUtils = require('../util/ajax');

const config = (FlexApiRequest, storeUtils = window.flex) => {

    const { getHeaders, handleAjaxError } = ajaxUtils(storeUtils);
    const { getStore, setStore } = storeUtils;

    let {
        appContext: { isDevMode }
    } = getStore();

    FlexApiRequest.addTrackingProvider('newrelic');

    FlexApiRequest.addBeforeSend(config => {
        // Assign flex headers to flex request
        Object.assign(config.headers, getHeaders());
        Object.assign(config, { isDevMode });
    });

    FlexApiRequest.addErrorHandler(({ jqXHR, textStatus, errorThrown, config, payload, instance, constructor }) => {
        let handledErrors = handleAjaxError(jqXHR, textStatus, errorThrown);
        setStore({ error: errorThrown });

        let errorObject = arguments[0];
        errorObject.handledErrors = handledErrors;
        errorObject.jqXHR = jqXHR;

        errorObject.store = getStore();
        return errorObject;
    });

    FlexApiRequest.addBeforeResponse(response => {
        // Any basic response parsing.... from json, etc
        response.store = getStore();
        return response;
    });

    FlexApiRequest.addTransformer(response => {
        // Any response transformations to take place before it reaches the caller

        return response;
    });
};

module.exports = config;